import { render, staticRenderFns } from "./GroupDashboardMain.vue?vue&type=template&id=1bc2ef0c"
import script from "./GroupDashboardMain.vue?vue&type=script&lang=js"
export * from "./GroupDashboardMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports